/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  webpage,
  eventService,
  navigationService,
  organizationService,
  messagesService,
  changesService,
  OrganizationFeatures,
  OpportunityConfiguration,
  uiService
) => {
  $scope.Model = {
    availableMessages: null,
    isReady: false
  };

    /*
     * Initialize controller and start loading the required data
     * --------------------------------------------------------------------------------
     */
    webpage.pageTitle('Loading, please wait');
    if ($rootScope.CurrentAccount.isAdministrator) {
      $q.all([
        organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
        messagesService.getAvailable({ type: ['email'] })
      ])
        .then((data) => {
          // Overwrite $rootScope values in case they've reverted to values within Token
          // eslint-disable-next-line no-param-reassign
          $rootScope.CurrentOrganization.features = OrganizationFeatures.build(
            data[0].features
          );
          // Set Model values
          $scope.Model.availableMessages = _.map(data[1], (m) => ({
            id: m.id,
            name: m.name
          }));
        })
        .then(() => {
          // Declare Model as Ready and start rendering the page
          webpage.pageTitle('Diversification : Settings');
          $scope.Model.isReady = true;
        });
    }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.referralAdd = (diversification) => {
    diversification.configuration.push(OpportunityConfiguration.blank());
  };

    $scope.referralDelete = (diversification, idx) => {
      diversification.configuration.splice(idx, 1);
      $scope.toggleChanges();
    };

  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const payload = {
      id: $rootScope.CurrentOrganization.id,
      features: {
        configDiversification: $rootScope.CurrentOrganization.features.configDiversification
      }
    };
    return organizationService.updateOrganization(payload).then((result) => {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
